<template>
  <div class="map-elem-info land-ap-emergency">
    <div class="col-icon">
      <img class="resource-icon" :src="iconPath">
    </div>
    <div class="col-info">
      <div class="row1 mb6">
        <div class="ft-bold">
          <span class="ib lbl">日時: </span>
          <span class="ib val">{{dateDisp}}</span>
        </div>
        <div class="right-side mr8">
          <div class="move-buttons mt2">
            <button class="btn btn-primary btn-xs mr4" @click="showPrevious">
              <i class="fas fa-arrow-left"></i>
              前へ
            </button>
            <button class="btn btn-primary btn-xs" @click="showNext">
              次へ
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row2">
        <div>
          <span class="ib lbl">車両番号: </span>
          <span class="ib val">{{emergency.deviceName}}</span>
          <span class="ib lbl ml12">動画種別: </span>
          <span class="ib val">{{emergency.movieTypeDisp}}</span>
        </div>
      </div>
      <div class="row3 mb6">
        <div>
          <span v-show="emergency.localAddress">
            <span class="lbl">地名: </span>
            <span class="val">{{ emergency.localAddress }}</span>
          </span>
          <span v-show="emergency.landmarkDisp">
            <span class="lbl">場所: </span>
            <span class="val">{{ emergency.landmarkDisp }}</span>
          </span>
        </div>
      </div>
      <div class="row4 mb6">
        <div class="image-preview-area">
          <div class="image-box" v-if="savedImage">
            <img :src="savedImage" class="image" @click="showImage"/>
          </div>
        </div>
        <div class="buttons ta-right mr8" v-if="!!emergency.emergenciesLink">
          <button class="btn btn-sm btn-info" @click="openEmergencies">
            緊急通報を開く
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import extLandApEmergencyApi from 'src/apis/extLandApEmergency';
import { computed } from 'vue';
import type { MapElemInfo } from 'src/models';
import type { Emergency } from 'src/models/extLandApEmergency';
import useMapElemInfoImagePreview from 'src/composables/useMapElemInfoImagePreview';
import { dtFormat } from 'src/lib/dateHelper';

interface Props {
  elem: MapElemInfo<Emergency>;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: string, ...args: unknown[]): void;
}>();

const emergency = computed<Emergency>(() => props.elem.data);
const dateDisp = computed<string>(() => dtFormat(emergency.value.ts));

const modalTitle = computed<string>(() => `${dateDisp.value} - ${emergency.value.landmarkDisp || ''}`);
const downloadFilenameTemplate = computed<string>(() => {
  const emergencyTs = dtFormat(emergency.value?.ts, 'yyyymmddHHMMSS');
  return `${emergency.value?.id}_${emergencyTs}_$TIMESTAMP.jpg`;
});
const { showPrevious, showNext, savedImage, showImage } = useMapElemInfoImagePreview({
  emit,
  elem: computed(() => props.elem),
  refMapElemInfoData: emergency,
  fetchApiFn: () => { return extLandApEmergencyApi.getImage(emergency.value.id); },
  modalTitle,
  downloadFilenameTemplate,
});

const openEmergencies = () => {
  window.open(emergency.value?.emergenciesLink, '_blank');
};
const iconPath = '/static/img/land_ap_emergency_pin.png';

</script>

<style lang="scss" scoped>
.map-elem-info {
  .col-icon {
    margin-right: 4px;
    display: flex;
    flex-direction: column;
    .resource-icon {
      width: 42px;
      &.start {
        margin: -4px 0 0 0;
      }
      &.end {
        margin: -30px 0 0 0;
      }
    }
  }
  .col-info {
    .row1, .row2, .row3, .row4 {
      display: flex;
      justify-content: space-between;
    }
    .row1 {
      flex-wrap: wrap;
    }
    .lbl {
      margin-right: 4px;
    }
    .left-side {
      flex-grow: 1;
    }
    .buttons {
      width: 152px;
      min-width: 152px;
      align-self: flex-end;
    }
    .image-preview-area {
      display: flex;
      width: 100%;
      .image-box {
        cursor: pointer;
        position: relative;
        border: 1px solid #dddddd;
        margin-left: 6px;
        .image {
          max-height: 72px;
          max-width: 128px;
        }
      }
    }
  }
}
</style>
